import type { ReactNode } from "react";

import ElementNavBar from "./ElementNavbar/ElementNavbar";
import { NavItemType } from "./Navbar";
import SubMenuNavbar from "./SubMenuNavbar/SubMenuNavbar";

interface RenderNavItemsOptions {
  navItems: NavItemType[];
  open?: boolean;
  showLinkLogo?: boolean;
  showSections?: boolean;
  toggleNavbar?: () => void;
  onLinkClick?: () => void;
  /** Resolved active href (longest-prefix match) shared by every item. */
  activeHref?: string;
}

/**
 * Builds the navbar list and inserts a section label before the first item
 * of each new section. Shared by the desktop and mobile navbars.
 */
const renderNavItems = ({
  navItems,
  open = true,
  showLinkLogo = true,
  showSections = true,
  toggleNavbar,
  onLinkClick,
  activeHref,
}: RenderNavItemsOptions): ReactNode[] => {
  const nodes: ReactNode[] = [];
  let lastSection: string | undefined;

  navItems.forEach((item) => {
    if (showSections && item.section && item.section !== lastSection) {
      nodes.push(
        <li key={`navSection-${item.section}`} className="navSectionLabel">
          {item.section}
        </li>,
      );
    }

    if (item.section) {
      lastSection = item.section;
    }

    nodes.push(
      item.type === "submenu" ? (
        <SubMenuNavbar
          key={item.text}
          navItem={item}
          openParent={open}
          showLinkLogo={showLinkLogo}
          toggleNavbar={toggleNavbar}
          activeHref={activeHref}
        />
      ) : (
        <ElementNavBar
          key={(item.href ?? "") + item.text}
          navItem={item}
          open={open}
          showLinkLogo={showLinkLogo}
          onLinkClick={onLinkClick}
          activeHref={activeHref}
        />
      ),
    );
  });

  return nodes;
};

export default renderNavItems;
